"use strict";

import getNgModule from "getNgModule";
import angular from "angular";
var ngModule = getNgModule(__filename);

/**
 * tlTextInput: Directive "conteneur" qui orchestre les autres.
 * 1. Fournit le template HTML (input, icone, liste de suggestions).
 * 2. Décore la fonction $clear pour qu'elle vide aussi le modèle de suggestion.
 *
 * En option vous pouvez fournir une liste de suggestions :
 * ex:
 * suggestions="collaborateurs" (la liste d'objets pour la suggestion)
 *   suggestion-label="label" (attribut pour afficher dans la liste)
 *   suggestion-text="nom" (attribut pour mettre dans l'input quand on selectionne une des suggestion, par defaut label)
 *   suggestion-model="vm.contributeur" (model à mettre a jout avec l'element selectionné)
 */
ngModule.directive("tlTextInput", function ($parse) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    // Scope hérité pour que les directives communiquent
    template: "\n            <div tl-input-wrapper class=\"tl-text-input-wrapper\" ng-class=\"{ 'open': suggestionsVisible }\">\n                <input tl-text-clear tl-suggestions/>\n                <i class=\"text-icon fa fa-circle-xmark\" ng-click=\"$clear(); $event.stopPropagation();\" ng-show=\"notEmpty()\"></i>\n                <ul class=\"suggestions-list\" ng-if=\"suggestionsVisible && filteredSuggestions.length > 0\">\n                    <li ng-repeat=\"suggestion in filteredSuggestions\" \n                        ng-mousedown=\"selectSuggestion(suggestion)\" \n                        ng-class=\"{ 'active': $index === activeSuggestionIndex }\">\n                        {{ suggestion[suggestionLabel] }}\n                    </li>\n                </ul>\n            </div>\n        ",
    priority: 1000,
    // Priorité haute pour que sa fonction link s'exécute après celles des directives avec une priorité plus basse
    compile: function compile(tElement, tAttrs) {
      // 1. On transfère dynamiquement ng-model (et les attributs de suggestion) 
      // vers l'élément <input> enfant AVANT que les directives ne soient liées.
      var inputElement = tElement.find('input');
      var attrsToTransfer = ['ngModel', 'suggestions', 'suggestionLabel', 'suggestionText', 'suggestionModel'];
      attrsToTransfer.forEach(function (attrName) {
        if (tAttrs[attrName]) {
          var htmlAttrName = tAttrs.$attr[attrName]; // récupère le nom avec tirets (ex: "ng-model")
          inputElement.attr(htmlAttrName, tAttrs[attrName]);
          if (attrName === 'ngModel') {
            tElement.removeAttr(htmlAttrName); // Retire ng-model du div racine pour éviter les conflits
          }
        }
      });

      // 2. On retourne la fonction link
      return function link($scope, $el, $attrs) {
        // On récupère le vrai contrôleur ngModel directement depuis l'élément <input>
        var inputEl = $el.find('input');
        var ngModelCtrl = inputEl.controller('ngModel');

        // La fonction link du parent s'exécute après les controllers des enfants.
        // On peut donc décorer $clear, qui a été défini par tlTextClear.
        if ($scope.$clear && $attrs.suggestionModel) {
          var originalClear = $scope.$clear;
          var suggestionModelSetter = $parse($attrs.suggestionModel).assign;
          $scope.$clear = function () {
            originalClear.apply(this, arguments);
            // Vider le modèle de suggestion en plus du ngModel
            suggestionModelSetter($scope, undefined);
          };
        }
        $scope.notEmpty = function () {
          if (!ngModelCtrl) return false;
          var inputValue = ngModelCtrl.$viewValue || '';
          return inputValue.length > 0;
        };
      };
    }
  };
});

/**
 * tlSuggestions:  directive dédiée à la gestion des suggestions.
 * Elle est ajoutée sur l'input et contient toute la logique associée.
 */
ngModule.directive('tlSuggestions', function ($timeout, $parse) {
  return {
    restrict: 'A',
    require: 'ngModel',
    // On a besoin du ngModelController pour lire/écrire la valeur de l'input
    link: function link($scope, $element, $attrs, ngModelCtrl) {
      // Ne rien faire si l'attribut 'suggestions' n'est pas présent
      if (angular.isUndefined($attrs.suggestions)) {
        return;
      }
      $scope.filteredSuggestions = [];
      $scope.suggestionsVisible = false;
      $scope.activeSuggestionIndex = -1;
      $scope.suggestionLabel = $attrs.suggestionLabel || 'label';
      $scope.suggestionText = $attrs.suggestionText || 'label';
      var suggestions = [];
      var suggestionModelSetter = $attrs.suggestionModel ? $parse($attrs.suggestionModel).assign : angular.noop;

      // Surveiller la collection de suggestions pour les chargements asynchrones
      $scope.$watch($attrs.suggestions, function (newVal) {
        suggestions = newVal || [];
      });
      var filterSuggestions = function filterSuggestions() {
        var inputValue = ngModelCtrl.$viewValue || '';
        if (inputValue.length > 0 && suggestions && suggestions.length > 0) {
          $scope.filteredSuggestions = suggestions.filter(function (item) {
            return item[$scope.suggestionLabel] && item[$scope.suggestionLabel].toLowerCase().includes(inputValue.toLowerCase());
          });
          $scope.suggestionsVisible = $scope.filteredSuggestions.length > 0;
          if (!$scope.suggestionsVisible) {
            suggestionModelSetter($scope, null);
          }
        } else {
          $scope.suggestionsVisible = false;
          suggestionModelSetter($scope, null);
        }
        $scope.activeSuggestionIndex = -1;
      };
      $scope.selectSuggestion = function (suggestion) {
        var text = suggestion[$scope.suggestionText];
        ngModelCtrl.$setViewValue(text);
        ngModelCtrl.$render();
        suggestionModelSetter($scope, suggestion);
        $scope.suggestionsVisible = false;
      };
      $element.on('input focus', function () {
        return $scope.$apply(filterSuggestions);
      });
      $element.on('blur', function () {
        return $timeout(function () {
          $scope.suggestionsVisible = false;
          suggestionModelSetter($scope, null);
        }, 200);
      });
      $element.on('keydown', function (event) {
        if (!$scope.suggestionsVisible) return;
        $scope.$apply(function () {
          switch (event.keyCode) {
            case 38:
              // Up
              event.preventDefault();
              if ($scope.activeSuggestionIndex > 0) $scope.activeSuggestionIndex--;
              break;
            case 40:
              // Down
              event.preventDefault();
              if ($scope.activeSuggestionIndex < $scope.filteredSuggestions.length - 1) $scope.activeSuggestionIndex++;
              break;
            case 13:
              // Enter
              if ($scope.activeSuggestionIndex > -1) {
                event.preventDefault();
                $scope.selectSuggestion($scope.filteredSuggestions[$scope.activeSuggestionIndex]);
              }
              break;
            case 27:
              // Escape
              $scope.suggestionsVisible = false;
              break;
          }
        });
      });
    }
  };
});

/**
 * tlTextClear: Directive originale, INCHANGÉE.
 * Son unique rôle est de fournir la fonction $clear pour vider le ngModel.
 */
ngModule.directive('tlTextClear', function () {
  return {
    require: ['tlTextClear', 'ngModel'],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0];
      var modelCtrl = controllers[1];
      ctrl.setNgModelCtrl(modelCtrl);
    },
    controller: function controller($scope, $element) {
      var ctrl = this;
      ctrl.setNgModelCtrl = function (ngModelCtrl) {
        ctrl.ngModelCtrl = ngModelCtrl;
      };
      $scope.$clear = function () {
        if ($element.attr('disabled') === 'disabled' || $element.attr('readonly') === 'readonly') {
          return;
        }
        ctrl.ngModelCtrl.$setViewValue(null);
        ctrl.ngModelCtrl.$render();
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/inputs/tl-text-input.js
// module id = 2978
// module chunks = 13